<div class="club-post-like-preview">
  <div *ngFor="let like of likes">
    <nz-avatar
      class="profile"
      [nzText]="likeAvatarText(like)"
      [ngStyle]="{ backgroundColor: stc(likeAvatarKey(like)) }"
      [nzSize]="25"
    ></nz-avatar>
  </div>
  <div class="club-post-like-extra" *ngIf="likes && likesCount > likes.length">
    y {{ likesCount - likes.length }} más
  </div>
</div>
